
    import '/opt/buildhome/repo/components/suggestion/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["suggestion-demo-basic","suggestion-demo-block","suggestion-demo-trigger"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/components/suggestion/index.en-US.md?type=demo')
};